import { render, staticRenderFns } from "./DualWrapper.vue?vue&type=template&id=5424c045&scoped=true"
import script from "./DualWrapper.vue?vue&type=script&lang=js"
export * from "./DualWrapper.vue?vue&type=script&lang=js"
import style0 from "./DualWrapper.vue?vue&type=style&index=0&id=5424c045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424c045",
  null
  
)

export default component.exports